import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f516784c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "component-socket-values-wrapper" };
const _hoisted_2 = { class: "component-socket-values-wrapper__list" };
import { ref, computed } from "vue";
import Button from "src/shared/v-components/ui/Button.vue";
import RewardSupplierIdListPicker from "./RewardSupplierIdListPicker.vue";
import RewardSupplierDisplayName from "./RewardSupplierDisplayName.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'RewardSupplierIdListVariableRawValue',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isStringList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const selectionsProxy = computed({
            get() {
                return isStringList(props.modelValue) ? props.modelValue : [];
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        const isAddMode = ref(false);
        const startAdding = () => {
            isAddMode.value = true;
        };
        const removeSelection = (rewardSupplierId) => {
            selectionsProxy.value = selectionsProxy.value.filter((selection) => selection !== rewardSupplierId);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectionsProxy.value, (selection) => {
                        return (_openBlock(), _createBlock(RewardSupplierDisplayName, {
                            key: selection,
                            rewardSupplierId: selection,
                            onRemove: removeSelection
                        }, null, 8 /* PROPS */, ["rewardSupplierId"]));
                    }), 128 /* KEYED_FRAGMENT */)),
                    _withDirectives(_createVNode(RewardSupplierIdListPicker, {
                        modelValue: selectionsProxy.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectionsProxy).value = $event)),
                        addMode: isAddMode.value,
                        "onUpdate:addMode": _cache[1] || (_cache[1] = ($event) => ((isAddMode).value = $event))
                    }, null, 8 /* PROPS */, ["modelValue", "addMode"]), [
                        [_vShow, isAddMode.value]
                    ]),
                    (!isAddMode.value)
                        ? (_openBlock(), _createBlock(Button, {
                            key: 0,
                            level: 'bordered',
                            onClick: startAdding
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(" + New Redemption Option ")
                            ]),
                            _: 1 /* STABLE */
                        }))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
